import React from "react";
import { Button, Box } from "@material-ui/core";
import classes from "./Modal.module.scss";

type ModalFooterProps = {
  primaryAction?: () => void;
  secondaryAction?: () => void;
  primaryLabel?: string;
  secondaryLabel?: string;
  disablePrimary?: boolean;
  disableSecondary?: boolean;
  disableUIActions?: boolean;
};

const ModalFooter: React.FC<ModalFooterProps> = ({
  primaryAction,
  secondaryAction,
  primaryLabel,
  secondaryLabel,
  disablePrimary = false,
  disableSecondary = false,
  disableUIActions = false,
}) => (
  <Box className={classes.modalFooterContainer}>
    {secondaryAction && secondaryLabel && (
      <Button
        variant="outlined"
        onClick={secondaryAction}
        style={{ marginRight: "1rem" }}
        disabled={disableSecondary}
      >
        {secondaryLabel}
      </Button>
    )}
    {primaryAction && primaryLabel && !disableUIActions && (
      <Button
        variant="contained"
        color="primary"
        onClick={primaryAction}
        disabled={disablePrimary}
      >
        {primaryLabel}
      </Button>
    )}
  </Box>
);

export default ModalFooter;
